import vueComponentOptions from 'components/InputLonLat.vue';

const LatLontInput = Vue.extend(vueComponentOptions);

module.exports = LatLontInput;
